import axiosInstance from "./instance";

// Get All Product by Status
const fetchProducts = async (page, status) => {
    const response = await axiosInstance.get('/products', {
        params: {
            page,
            status
        }
    });
    return response.data;
}

// Get Solo Product Details
const fetchProduct = async (productId) => {
    const response = await axiosInstance.get(`/product`, {
        params: {
            productId
        }
    });
    return response.data;
}

// Update Product Status
const updateProduct = async (productId, status) => {
    const response = await axiosInstance.put('/product', {
        productId,
        status
    });
    return response.data;
}

export { fetchProducts, fetchProduct, updateProduct };